/**
 * Piece Icon Component
 * Renders chess piece symbols including jester
 */

import React from 'react';
import type { Piece } from '@jester-chess/shared';
import './PieceIcon.css';

interface PieceIconProps {
  piece: Piece;
}

export const PieceIcon: React.FC<PieceIconProps> = ({ piece }) => {
  const getPieceSymbol = (): string => {
    switch (piece.type) {
      case 'king':
        return piece.color === 'white' ? '♔' : '♚';
      case 'queen':
        return piece.color === 'white' ? '♕' : '♛';
      case 'rook':
        return piece.color === 'white' ? '♖' : '♜';
      case 'bishop':
        return piece.color === 'white' ? '♗' : '♝';
      case 'knight':
        return piece.color === 'white' ? '♘' : '♞';
      case 'pawn':
        return piece.color === 'white' ? '♙' : '♟';
      case 'jester':
        // Jesters are represented as checkers pieces
        return piece.color === 'white' ? '⚪' : '⚫'; // White and black checkers pieces
      default:
        return '';
    }
  };

  return (
    <div className={`piece-icon ${piece.color} ${piece.type}`}>
      {getPieceSymbol()}
    </div>
  );
};

